module.exports = {
  platform: 'chat',
  name: 'Input',
  node: 'chat_input',
  bg: '#FFFFFF',
  note: '',
  property: {
    config: {
      is_customize_input: false,
      setting: {
        max_input_timeout: 5
      },
      default_input: {
        is_count_retry: undefined,
        nlu: ''
      }
    },
    content: '${data_from_social}'
  }
}
